import axios, { AxiosPromise } from 'axios'
// import applyCaseMiddleware from 'axios-case-converter'
import { AuthInterceptorRequestFullfiled } from 'src/services/interceptors/request'
import {
  INormalizeResponse,
  NormalizeInterceptorResponseFullfiled,
  ErrorProcessing,
} from 'src/services/interceptors/response'
import * as locationService from 'src/services/location'

export const partner = locationService.getPartner()
export const domain = window.settings.BASE_AGENTS_DOMAIN

export const baseURL = `//${domain}/api`
export const baseURLWithoutPartner = `//${domain}/api`

export type IResponse<data> = INormalizeResponse<data>
export type HTTPPromise<Data> = AxiosPromise<Data>

export const http = axios.create({
  baseURL,
  withCredentials: false,
})

// applyCaseMiddleware(http)

http.interceptors.request.use(AuthInterceptorRequestFullfiled)

http.interceptors.request.use((config) => {
  config.headers['X-CRM-Subdomain'] = partner
  config.headers['X-CRM-Base-Domain'] = domain

  return config
})

http.interceptors.response.use(
  NormalizeInterceptorResponseFullfiled,
  ErrorProcessing
)
